import React from 'react'
import { IBadgeProps } from './interfaces'
import Icon from '@ant-design/icons'
import { FiRadio } from 'react-icons/fi'
import { Tooltip } from 'antd'

/**
 * Marks a notification as having been created by a feed, and names the feed in its tooltip.
 *
 * `FiRadio` is wrapped in antd's `Icon` so it renders as an `.anticon`, the same as every other
 * badge in a row's strip. That class carries the baseline shift these icons are drawn against
 * (`vertical-align: -0.125em`), so wrapping keeps it level with its neighbours rather than
 * hard-coding the offset here. Antd injects `fill="currentColor"`, which would flood-fill an
 * outline glyph, so it is overridden with `fill="none"`; the stroke still inherits, leaving the
 * icon the colour of the row rather than accented.
 */
export const NotificationFeedBadge: React.FC<IBadgeProps> = (props) => {
    const badge = (
        <span className="icon-feed">
            <Icon component={(iconProps: any) => <FiRadio {...iconProps} fill="none" />} aria-hidden="true" />
        </span>
    )

    return (
        <span className="notification-feed-badge">
            {props.hideTooltip ? badge : <Tooltip title={props.tooltip || 'Created from Feed'}>{badge}</Tooltip>}
        </span>
    )
}
